import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

const cleanParagraphWhitespacePluginKey = new PluginKey('cleanParagraphWhitespace');

export default Extension.create({
  name: 'cleanParagraphWhitespace',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: cleanParagraphWhitespacePluginKey,

        props: {
          handleDOMEvents: {
            blur: view => {
              const { state, dispatch } = view;
              const { tr } = state;
              const deletionRanges: { from: number; to: number }[] = [];

              state.doc.descendants((node: any, pos: number) => {
                if (node.type.name === 'paragraph') {
                  const text = node.textContent.replace(/\u00A0/g, '').trim();

                  if (node.content.size > 0 && text === '') {
                    deletionRanges.push({ from: pos + 1, to: pos + 1 + node.content.size });
                  }
                }
              });

              deletionRanges.reverse().forEach(range => tr.delete(range.from, range.to));

              if (deletionRanges.length > 0) dispatch(tr);

              return false;
            },
          },
        },
      }),
    ];
  },
});
